// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2I0o5","col":"styles_col__3pamS"};